import { Card, Typography, Button, Pagination } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import AddDiscountCodes from "../../Modal/AddDiscountCodes";
import { getData } from "../../utils";
import TableRows from "./TableRows";
import { useLoaderProvider } from "../../context/LoaderProvider";

const ManageDiscountCodes = () => {
  const [addDiscountCodes, setAddDiscountCodes] = useState(false);
  const [data, setData] = useState([]);
  const { updateLoader } = useLoaderProvider();
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  const getCouponData = async () => {
    try {
      let res = await getData(`/v1/admin/coupon/get?page=${page}`, true);
      if (res.status === "success") {
        setData(res.data);
        setTotal(res.total);
      }
    } catch (e) {}
  };

  useEffect(() => {
    updateLoader(true);
    getCouponData();
    updateLoader(false);
  }, [page]);

  return (
    <>
      {addDiscountCodes && (
        <AddDiscountCodes
          isOpen={addDiscountCodes}
          onCancel={() => {
            setAddDiscountCodes(false);
          }}
          callback={() => {
            setAddDiscountCodes(false);
            getCouponData();
          }}
        />
      )}
      <Card>
        <div className="flex justify-between items-center mb-4 gap-3">
          <Typography className="text-xl font-semibold" align={"left"}>
            Manage Discount codes
          </Typography>
          <div className="flex justify-end gap-3">
            <Button
              type="primary"
              icon={<PlusOutlined />}
              size={14}
              onClick={() => {
                setAddDiscountCodes(true);
              }}
            >
              Add discount codes
            </Button>
          </div>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-gray-700 bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3">
                  Unique code name
                </th>
                <th scope="col" className="px-3 py-3">
                  End date
                </th>
                <th scope="col" className="px-3 py-3">
                  Code type
                </th>
                <th scope="col" className="px-3 py-3">
                  Flat amount
                </th>
                <th scope="col" className="px-3 py-3">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {data.length
                ? data.map((element, ind) => {
                    return (
                      <TableRows
                        rows={element}
                        key={ind}
                        callback={() => {
                          getCouponData();
                        }}
                      />
                    );
                  })
                : null}
            </tbody>
          </table>
        </div>
        <div className="flex justify-between items-center mt-4">
          <div className="text-base font-semibold">
            Total Discount codes - <span className="font-normal">{total}</span>
          </div>
          {total > 10 && <Pagination defaultCurrent={page} total={total} onChange={(e) => setPage(e)} />}
        </div>
      </Card>
    </>
  );
};

export default ManageDiscountCodes;
